import api from "../services/api";

// Role
export const addSubAdmin = (data) => {
    return api.post('admin/subadmin/add_user', data);
}

export const updateSubAdmin = (data) => {
    return api.put('admin/subadmin/update_user', data);
}

export const updateSubAdminStatus = (data) => {
    return api.put('admin/subadmin/update_user_status', data);
}

export const deleteSubAdmin = (id) => {
    return api.delete('admin/subadmin/delete_user', {
        data: { _id: id }
    });
}

export const getSubAdminList = (queryParams = "") => {
    return api.get(`/admin/subadmin/users_list${queryParams}`);
};